//import moment from "moment";
//import AppConfig from "../AppConfig/AppConfig.js";
//import PdfObservation from "../lib/Pdf/PdfObservation.js"

import {formatISO, format} from "date-fns";

import ConfigService from "../../../services/ConfigService"
import ServiceDataResponse from "../../../models/ServiceDataResponse";
import IdentityService from "../../../services/IdentityService";
import LocalStorageService from "../../../services/LocalStorageService";

import ReportDataFactory from "../../ReportViewer/Reports/Managers/ReportDataFactory";


function getProp(obj, prop) {
    if (typeof obj !== 'object') throw 'getProp: obj is not an object'
    if (typeof prop !== 'string') throw 'getProp: prop is not a string'

    // Replace [] notation with dot notation
    prop = prop.replace(/\[["'`](.*)["'`]\]/g,".$1")

    return prop.split('.').reduce(function(prev, curr) {
        return prev ? prev[curr] : undefined
    }, obj || this.self)
}

export default class NotificationManager
{
        constructor()
        {
            this.configService = new ConfigService();
            this.LocalStorageService = new LocalStorageService();
        }


        async getDirectNotificationResult(fromUser, toList, directMessage, observation, reportName, templateId, userId, gcid, token)
        {
            var result = {
                    "id": IdentityService.makeUuid(), //observation.data.identifiers.id, // TBD should be GUID unique to notification event
                    "gcid": observation.data.Raw.gcid,
                    "sourceService": "glasschain-qa-app",
                    "sourceId": observation.identifiers.id,
                    "sourceDescript": "Observation",
                    "sourceMessage": directMessage,
                    "sourceComment": "created by glasschain Observations",
                    "requestedBy": fromUser, //observation.data.UnderInspection.Inspector,
                    "requestDate":  formatISO(new Date(), "MM/dd/yyyy"),
                    "toList": toList
            };  

            console.group("Template Data");
            console.log("about to build templateData from observation object:");
            console.groupEnd();
            var reportDataResponse = await ReportDataFactory.ReportData(reportName, observation, userId, gcid, token);
            if (reportDataResponse.hasError)
            {
                return reportDataResponse;
            }
            var templateData = reportDataResponse.data;
            console.info(templateData);
            // add additional fields required by email
            var orgConfig = this.LocalStorageService.getOrgConfig(gcid);
            let senderLogo = this.configService.getCustomerLogoImagePath(gcid);
            var nameAppend = (orgConfig.Names?.longName) ? "from " + orgConfig.Names.longName : "";
            var receiptId = (observation.data.Raw.mraInfo?.tagId) ? " for Receipt " + observation.data.Raw.mraInfo?.tagId : "";
            templateData.subject = nameAppend + " QA Notification " + receiptId,
            templateData.Notification = {
                "requestDate":  format(new Date(), "MM/dd/yyyy"),
                "appHost": this.configService.getAppHost(),
                "senderGcid": observation.data.Raw.gcid,
                "senderMessage": directMessage,
                "senderName": fromUser,
                "senderLogoUri": senderLogo
            }

            result.Message = {
                "templateId": templateId, // "d-2e4553f161e0408fafecab1d6d5bb750",
                "fromPrefix": "observations",
                "templateData": JSON.stringify(templateData)
            };
    
            console.groupEnd();
            return new ServiceDataResponse(result, false, "Report Data Generated.");
    
        }
    


}


